import * as React from "react";
import LazyLoad from "react-lazyload";
import { UitkImage } from "uitk-react-images";
import { TripImageProps } from "../typings";
import { locKeys } from "../l10n";
import { ImagePlaceholder } from "./ImagePlaceholder";
import { useLocalization } from "@shared-ui/localization-context";

export const TripImage = (props: TripImageProps) => {
  const { imageData } = props;
  const { formatText } = useLocalization();

  if (imageData && imageData.alt && imageData.url) {
    return (
      <LazyLoad offset={100} once placeholder={<ImagePlaceholder alt={imageData.alt} />}>
        <UitkImage alt={imageData.alt} src={imageData.url} />
      </LazyLoad>
    );
  }

  return <ImagePlaceholder alt={formatText(locKeys.imagePlaceHolder, props.destinationName)} />;
};
